export default "__VITE_ASSET__Dps5Dc5b__"